import { useMemo } from 'react';
import { SWRConfiguration } from 'swr';

import {
  UserActivityEvent,
  UserActivityEventsGetParams,
} from '~/data/userActivity/types';
import { useGetUserActivityEvents } from '~/data/userActivity/useGetUserActivityEvents';
import { UserActivityEventListResultDto } from '~/services/Http/client.iam.generated';

type UserActivityMetaData = Omit<
  UserActivityEventListResultDto,
  'data' | 'init' | 'toJSON'
>;

type UseGetUserViewActivityOutput = {
  data: UserActivityEvent[];
  metaData: UserActivityMetaData;
  isLoading: boolean;
  isValidating: boolean;
  failedToLoad: boolean;
  mutate: () => void;
};

export const useGetUserViewActivity = (
  props: UserActivityEventsGetParams,
  swrConfig?: SWRConfiguration,
): UseGetUserViewActivityOutput => {
  const {
    data: rawData,
    isLoading,
    isValidating,
    failedToLoad,
    mutate,
  } = useGetUserActivityEvents(props, swrConfig);

  const { data, metaData } = useMemo((): {
    data: UserActivityEvent[];
    metaData: UserActivityMetaData;
  } => {
    if (!!rawData) {
      const { data, ...metaData } = rawData;
      return {
        data: (data ?? []) as UserActivityEvent[],
        metaData,
      };
    }

    return {
      data: [],
      metaData: {},
    };
  }, [rawData]);

  return {
    data,
    metaData,
    isLoading,
    isValidating,
    failedToLoad,
    mutate: () => {
      mutate();
    },
  };
};
